defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubsList',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubCard',
  ],
  function (m, ClubCard) {
    // Context:
    const ClubList = function (controller) {
      const clubsList = controller.clubs();
      const dictionary = controller.rootDictionary.get.bind({ prefix: 'ViewMyClubs/ClubCard/' });

      // Return:
      return m('.play-together-clubs-list', clubsList.map((club) => {
        return m(ClubCard, {
          controller,
          club,
          action: {
            text: dictionary('GoToClubButton'),
            href: `${controller.navigationPaths.clubPage}?klubId=${club.fields.clubId()}`
          }
        });
      }));
    };

    // Public functions:
    return ClubList;
  });
